var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../contexts/auth.context';
import { Loader } from '../index';
import { getProfile, getRoles, getToken } from '../services/auth/authService';
import { useQuery } from '../hooks/useQuery';
import { setTokenToLocalStorage, setUserToLocalStorage, tokenHasExpired } from '../services/localStorage/localStorageService';
export function Callback() {
    var history = useHistory();
    var _a = useAuth(), setToken = _a.setToken, token = _a.token, setUser = _a.setUser;
    var state = useState(useQuery().get('state') || undefined)[0];
    var tokenCode = useState(useQuery().get('code') || undefined)[0];
    useEffect(function () {
        if (!token || tokenHasExpired()) {
            var stateToken = {
                state: state,
                code: tokenCode,
            };
            getToken(stateToken)
                .then(function (res) {
                var tokenData = res.data;
                setTokenToLocalStorage(tokenData.access_token);
                setToken(tokenData.access_token);
                getProfile(tokenData.access_token)
                    .then(function (profileData) {
                    getRoles().then(function (rolesData) {
                        var userData = __assign(__assign({}, profileData.data), rolesData.data);
                        setUserToLocalStorage(userData);
                        setUser(userData);
                    });
                })
                    .finally(function () {
                    var targetUrl = localStorage.getItem('returnUrl') || '';
                    if (!targetUrl || targetUrl === 'index') {
                        targetUrl = '/';
                    }
                    history.replace(targetUrl);
                });
            })
                .catch(function () {
                history.replace('/login');
            });
        }
        // eslint-disable-next-line
    }, []);
    return (_jsxs("div", __assign({ className: 'fixed-full-page' }, { children: [_jsx("div", __assign({ className: 'fixed-centered-loader' }, { children: _jsx(Loader, {}) })), _jsx("div", __assign({ className: 'fixed-centered-text' }, { children: "Logging in..." }))] })));
}
export default Callback;
